import CAPABILITIES from './capabilities';

//

const USER_TYPE = {
  lead: 1,
  learningTools: 2,
  client: 3,
  other: 4,
  employee: 5,
  student: 6,
};

const USER_TYPE_CAPABILITIES = {
  // 1. All capabilities are enabled by default, so setting `someFeature: true` is redundant
  // 2. `labAccess` being `false` blocks everything but creating/converting a user
  // 3. The combination of `labAccess` and `newUserCreation` being `false blocks all other
  //    capabilities
  [USER_TYPE.client]: {
    [CAPABILITIES.agendaAccess]: false,
  },
  [USER_TYPE.employee]: {
    [CAPABILITIES.agendaAccess]: false,
    [CAPABILITIES.activityLabAccess]: false,
    [CAPABILITIES.profileManagement]: false,
    [CAPABILITIES.userConversion]: false,
  },
  [USER_TYPE.lead]: {
    [CAPABILITIES.labAccess]: false,
    [CAPABILITIES.userConversion]: false,
  },
  [USER_TYPE.learningTools]: {
    [CAPABILITIES.labAccess]: false,
  },
  [USER_TYPE.other]: {
    [CAPABILITIES.newUserCreation]: false,
    [CAPABILITIES.labAccess]: false,
    [CAPABILITIES.userConversion]: false,
  },
  [USER_TYPE.student]: {
    [CAPABILITIES.assessmentManagement]: false,
    [CAPABILITIES.activityLabAccess]: false,
    [CAPABILITIES.newUserCreation]: false,
    [CAPABILITIES.profileManagement]: false,
    [CAPABILITIES.recommendations]: false,
    [CAPABILITIES.shareWithTutorControls]: false,
    [CAPABILITIES.subjectManagement]: false,
    [CAPABILITIES.userConversion]: false,
  },
};

const USER_TYPE_NAME = {
  [USER_TYPE.client]: 'client',
  [USER_TYPE.employee]: 'employee',
  [USER_TYPE.lead]: 'lead',
  [USER_TYPE.learningTools]: 'learning-tools',
  [USER_TYPE.other]: 'other',
  [USER_TYPE.student]: 'student',
};

// Exports
// -------

export { USER_TYPE, USER_TYPE_CAPABILITIES, USER_TYPE_NAME };

export default USER_TYPE;
